<template>
  <v-container fluid>
 
  <v-card>
     
    <v-card-title  :class="{ 'titulo_config': this.caso_base === true }">
      {{ $t('simulacion.modulo.electrolizador_rend.titulo') }}
    </v-card-title>
    <v-divider :thickness="caso_base ? 3 : 1" class=" my-2"></v-divider>
    <v-row justify="end">
        <v-col cols="auto">
            <v-btn
            :disabled="this.disabled"
            class="btn-guardar"
            v-if="caso_base === true"
            color="primary"
            @click="guardar_curvas_elec_generales()"
            >
            {{ $t('pestana_configuracion.guardar') }}
            </v-btn>
      </v-col>
    </v-row>
    <v-card-text>

      <v-container>
        <ComponenteLoading  :is-loading="loading" :message="mensaje_loading"/>
        <v-row no-gutters>
          <!-- Tabla más estrecha -->
          <v-col cols="5" class="pr-4">
            <v-card-title class="text-subtitle-1 font-weight-bold">
              
            </v-card-title>

            <v-data-table
            :disabled="this.disabled"
            :key="tableKey"
              :headers="headersCurva"
              :items="curva"
              hide-default-footer
              item-value="id"
              class="mb-2"
              dense
            >
              <template #item="{ item, index }">
                <tr>
                  <td>
                    <v-text-field
                    :disabled="this.disabled"
                      v-model.number="item.uso"
                      type="number"
                      density="compact"
                      hide-details
                      @blur="ordenarCurva"
                    />
                  </td>
                  <td>
                    <v-text-field
                    :disabled="this.disabled"
                      v-model.number="item.eficiencia"
                      type="number"
                      density="compact"
                      hide-details
                    />
                  </td>
                  <td>
                    <v-btn :disabled="this.disabled" icon @click="eliminarPunto(index)" color="red" size="small">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-btn :disabled="this.disabled" color="primary" class="mb-2" @click="agregarPunto">
              <v-icon start>mdi-plus</v-icon> {{ $t('simulacion.modulo.electrolizador_rend.anadir_fila') }}
            </v-btn>
          </v-col>

          <!-- Gráfica separada y más ancha -->
          <v-col cols="7">
            <ComponenteGrafica :options="chartOptions" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
   </v-container>
</template>

<script>
import ComponenteGrafica from './ComponenteGrafica.vue';
import ComponenteLoading from './ComponenteLoading.vue';
import JSZip from 'jszip';
import axios from 'axios';
import store from '../store';
export default {
  components: { ComponenteGrafica, ComponenteLoading },
  props: {
    disabled:{
      type:Boolean,
      default:false,
    },
    value: {
      type: Array,
      required: true,
    },
      caso_base: {
      type: Boolean,
      required: true,
      default: null,
      
    },
    desdeSim:{
      required:true,
      default:false,
    }
  },
  emits: ['update:value'],
  data() {
    return {
      loading:false,
      mensaje_loading:"",
      curva_local: [],
      tableKey: 0,
      headersCurva: [
        { title: this.$t('simulacion.modulo.electrolizador_rend.uso_electrolizador'), value: 'uso', align: 'center' },
        { title: this.$t('simulacion.modulo.electrolizador_rend.eficiencia_electrolizador'), value: 'eficiencia', align: 'center' },
        { title: '', value: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    curva() {
      return this.curva_local || [];
    },
    chartOptions() {
      const chartData = this.curva.map(p => [p.uso, p.eficiencia]);
      console.log(" Datos para gráfico:", chartData);

      return {
        title: {
          text: this.$t('simulacion.modulo.electrolizador_rend.titulo_curva'),
          left: 'center',
          top: 10
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {
          left: 80,
          right: 40,
          bottom: 70,
          top: 60
        },
        xAxis: {
          type: 'value',
          name: 'Carga (%)',
          nameLocation: 'middle',
          nameGap: 35
        },
        yAxis: {
          type: 'value',
          name: 'Eficiencia (kWh/kg)',
          nameLocation: 'middle',
          nameGap: 40
        },
        series: [
          {
            name: 'Eficiencia',
            type: 'line',
            smooth: true,
            symbolSize: 8,
            data: chartData
          }
        ]
      };
    }
  },
  watch: {
     value: {
    handler(nuevoValor) {
      const nuevoIds = nuevoValor.map(e => e.id).join(',');
      const actualIds = this.curva_local.map(e => e.id).join(',');
      if (
        nuevoValor.length !== this.curva_local.length ||
        nuevoIds !== actualIds ||
        JSON.stringify(nuevoValor) !== JSON.stringify(this.curva_local)
      ) {
        console.log('Reseteando curva_local tras importación');
        this.curva_local = JSON.parse(JSON.stringify(nuevoValor));
        this.tableKey++; 
      }
    },
    immediate: true,
    deep: true
  },
    curva_local: {
      handler(nuevaCurva) {
        const nuevoStr = JSON.stringify(nuevaCurva);
        const actualStr = JSON.stringify(this.value);
        if (nuevoStr !== actualStr) {
          console.log("Emitting update:value");
          this.$emit('update:value', nuevaCurva);
        }
      },
      deep: true
    }
  },
  mounted(){
    if(!this.desdeSim){
        this.obtener_curvas_elec_generales()
      }
  },
  methods: {

    async obtener_curvas_elec_generales(){
     
          
      this.loading = true;
      this.mensaje_loading = "Cargando curvas electrolizador generales...";

          await axios({
              method: 'get',
              url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-curvas_elec-generales/",
              withCredentials: true,
              headers: {
                  Authorization: "Bearer " + store.state.token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json'
              },
              responseType: 'blob' 
          })
          .then((response) => {
              

              // Crear un objeto FileReader para leer el blob
              const fileReader = new FileReader();

              fileReader.onload = (event) => {
                  const arrayBuffer = event.target.result;

                  // Usar JSZip para descomprimir el archivo
                  JSZip.loadAsync(arrayBuffer).then((zip) => {
                      // Asumimos que el archivo JSON está en la raíz del ZIP
                      const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

                      if (fileName) {
                          zip.file(fileName).async("string").then((jsonContent) => {
                              
                              //console.log(JSON.stringify(jsonContent))
                              //this.datos = JSON.parse(jsonContent);
                              console.log("Datos rend",JSON.parse(jsonContent))
                              this.curva_local = JSON.parse(jsonContent);
                              
                              console.log(this.rows);
                          }).catch((err) => {
                              console.error("Error leyendo el archivo JSON del ZIP:", err);
                          });
                      } else {
                          console.error("No se encontró un archivo JSON en el ZIP.");
                      }
                  }).catch((err) => {
                      console.error("Error descomprimiendo el archivo ZIP:", err);
                  });
              };

              // Leer el blob como ArrayBuffer
              fileReader.readAsArrayBuffer(response.data);
          })
          .catch((error) => {
              
              console.error("Error al obtener las curvas:", error);
          });
    this.loading = false;
    },

    async guardar_curvas_elec_generales() {
    
          this.loading = true;
          this.mensaje_loading = "Guardando curvas electrolizador base...";
          console.log("Guardando")
          console.log(this.mensaje_loading)
          try {
            await axios.post(
              process.env.VUE_APP_API_BASE_URL + "/api/guardar-curvas_elec-generales/",
              this.curva_local,
              {
                withCredentials: true,
                headers: {
                  Authorization: "Bearer " + store.state.token,
                  "Content-Type": "application/json",
                },
                responseType: "json",
              }
            );
    
          } catch (error) {
            console.error("Error al guardar las curvas electrolizador :", error);
          } finally {
            this.loading = false;
          }
          console.log("Acabado")
      },

    ordenarCurva() {
      this.curva_local = [...this.curva_local.sort((a, b) => Number(a.uso) - Number(b.uso))];
    },
    agregarPunto() {
      this.curva_local.push({
        id: this.curva_local.length + 1,
        uso: null,
        eficiencia: null
      });
    },
    eliminarPunto(index) {
      this.curva_local.splice(index, 1);
      this.ordenarCurva();
    }
  }
};
</script>


<style scoped>
.v-btn {
  margin-top: 10px;
}
.btn-guardar{
  margin-right: 70px;
}
.titulo_config{
   font-size: 20px; 
   font-weight: 900; 
   margin-top: 2%;
   text-transform: uppercase; 
   letter-spacing: 1px;
}
</style>
